import React from 'react';
import { classNames } from './classNames';

export interface HtmlContentProps extends Omit<React.HTMLAttributes<HTMLElement>, 'children' | 'dangerouslySetInnerHTML'> {
  as?: React.ElementType;
  html: string;
}

const HtmlContent: React.FC<HtmlContentProps> = ({
  as: Component = 'div',
  className,
  html,
  ...props
}) => (
  <Component
    className={classNames(className)}
    dangerouslySetInnerHTML={{ __html: html }}
    {...props}
  />
);

export default HtmlContent;
